import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../core/authentication/authentication.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageDataService {

  private sessionStorage: any;
  private environment: Environment;

  constructor(
    private authenticationService: AuthenticationService
  ) {
    this.sessionStorage = sessionStorage;
    this.environment = environment;
  }

  public setItem(key: string, value: any) {
    this.sessionStorage.setItem(this.getUniqueKey(key), JSON.stringify(value));
    return this;
  }

  public getItem(key: string): any | null {
    return JSON.parse(this.sessionStorage.getItem(this.getUniqueKey(key)));
  }

  public removeItem(key) {
    this.sessionStorage.removeItem(this.getUniqueKey(key));
    return this;
  }

  public itemExists(key): boolean {
    return this.sessionStorage.getItem(this.getUniqueKey(key)) !== null;
  }

  private getUniqueKey(key: string): string {
    return this.authenticationService.currentUser.username + '-' + this.environment.key + '-' + key;
  }

}
